import UserSettingsService from "src/services/userSettingsService";

import { Product } from "@dashboard/products/types";

export function getDefaultProduct(products: Product[]): Product | null {
    if (products.length === 0) {
        return null;
    }
    const lastSelectedId = UserSettingsService.getProductPageLastSelectedProduct();
    return products.find((p) => p.id === lastSelectedId) ?? products[0];
}
